import { LazyRoute } from '@app/components/lazy-route';
import { PusherProviderWrapper } from '@app/components/pusher-provider';
import { useFlag } from '@app/feature-flags/use-flag';
import { FLAG_POST_EVENT_ADVANCED_EDITOR_SINGLE_RECORDING_EDIT } from '@app/utilities/flags';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { EditView } from '../components/edit-view';

export const EditViewRoute = () => {
  const isAdvancedEditorEnabled = useFlag(
    FLAG_POST_EVENT_ADVANCED_EDITOR_SINGLE_RECORDING_EDIT,
  );

  // Redirect to the editor index if the advanced editor flag is not enabled.
  // This prevents direct URL access to the edit route when the feature is off.
  if (!isAdvancedEditorEnabled) {
    return <Navigate to=".." replace />;
  }

  return (
    <LazyRoute>
      <PusherProviderWrapper>
        {/* PusherProviderWrapper is needed here because EditViewRoute is a sibling
            of Editor (not a child) — each sibling mounts its own provider instance.
            The underlying Pusher client is a singleton from DashboardReactiveMap,
            so there are no duplicate WebSocket connections. */}
        <div className="h-screen w-full bg-spring-neutral-base text-spring-neutral-b0 overflow-hidden">
          <EditView />
        </div>
      </PusherProviderWrapper>
    </LazyRoute>
  );
};
